import type { ConversationEntityRef } from '@confluent/shared/lib/conversation-ui/entity-refs';
import React from 'react';
import { OpenEntityButton } from '../entities/OpenEntityButton.js';

/**
 * Comp `.card` — shared shell for every card renderer:
 *   `.ch`       header: eyebrow + title + optional right-side badge, and Open when the card shows one record
 *   `.cb`       body
 *   `.actions`  footer (rendered only when actions are supplied)
 *
 * `entityRef`: the record the card shows; its Open control opens it inside the conversation (owner 2026-10-31).
 */
export function CardFrame({
  eyebrow,
  title,
  badge,
  actions,
  entityRef,
  bodyClassName = '',
  children,
}: {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  entityRef?: ConversationEntityRef | null;
  bodyClassName?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="rounded-xl border bg-surface overflow-hidden">
      <div className="flex items-center gap-2.5 px-3.5 py-2.5 border-b">
        <div className="min-w-0">
          {eyebrow != null && (
            <div className="font-mono text-[10px] uppercase tracking-[1.1px] text-faint">{eyebrow}</div>
          )}
          <h3 className="text-[13px] font-semibold text-heading">{title}</h3>
        </div>
        <div className="flex-1" />
        {badge}
        {entityRef && <OpenEntityButton entityRef={entityRef} />}
      </div>
      <div className={`p-3.5 ${bodyClassName}`}>{children}</div>
      {actions != null && <div className="flex flex-wrap gap-2 px-3.5 py-3 border-t">{actions}</div>}
    </div>
  );
}
